import { render, staticRenderFns } from "./RegionalManagers.vue?vue&type=template&id=32aff120&"
import script from "./RegionalManagers.vue?vue&type=script&lang=js&"
export * from "./RegionalManagers.vue?vue&type=script&lang=js&"
import style0 from "./RegionalManagers.vue?vue&type=style&index=0&id=32aff120&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports